import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

const services = [
  {
    title: "Brokerage",
    content:
      "With AYGI: Experience Your flagship yacht brokerage for seamless buying and selling. ",
    image:
      "https://hcbyachts.com/wp-content/uploads/2024/08/DJI_0077-2-scaled.jpg",
    link: "/services",
  },
  {
    title: "Financing",
    content:
      "AYGI secures flexible yacht financing through premier financial partnerships for you. ",
    image:
      "https://hcbyachts.com/wp-content/uploads/2024/08/DSC08432-copy-scaled.jpg",
    link: "/services",
  },
  {
    title: "Insurance",
    content:
      "Insure your yacht seamlessly with tailored marine insurance from AYGI Insurance Broker. ",
    image:
      "https://hcbyachts.com/wp-content/uploads/2024/08/DJI_0095-Enhanced-NR-4-scaled.jpg",
    link: "/services",
  },
  {
    title: "Transportation",
    content:
      "We offer expert Yacht Transportation: land or water, your choice. ",
    image: "https://hcbyachts.com/wp-content/uploads/2022/02/DJI_0024.jpg",
    link: "/services",
  },
  {
    title: "Trade-In",
    content:
      "We offer effortless yacht upgrade: trade-in your boat for a better vessel.",
    image: "https://hcbyachts.com/wp-content/uploads/2022/02/3HjULq0M-1.jpg",
    link: "/services",
  },
  {
    title: "Charter",
    content:
      "Charter a luxury yacht for your next adventure on the water with AYGI.",
    image: "https://hcbyachts.com/wp-content/uploads/2022/02/DSC_6455.jpg",
    link: "/charter",
  },
];

const HomeYachtServices = () => {
  return (
    <div className="py-4">
      <div class="col-lg-12 hr-line">
        <div class="d-flex justify-content-start">
          <h5 className="text-dark fw-bold ">Our Yacht Services</h5>
        </div>
      </div>
      <Row>
        {services.map((item, index) => (
          <Col key={index} xs={12} sm={6} md={4} lg={4} className="mb-4">
            <div className="yacht-tile">
              <img src={item.image} alt={item.title} />
              <div className="overlay">
                <h3>{item.title}</h3>
                <p>{item.content}</p>
                <Link to={item.link}>
                  <Button variant="light" size="sm" className="mt-2">
                    View More
                  </Button>
                </Link>
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default HomeYachtServices;
